import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2';
import VuetifyDialog from 'vuetify-dialog';
import HighchartsVue from 'highcharts-vue';
import vuePersianFilters from 'vue-persian-filters';
import NotificationPlugin from '@/plugins/notification-plugin';
import { FilterInputDirective } from '@/directives/filter-input-directive';
import './registerServiceWorker';
import '@mdi/font/css/materialdesignicons.css';
import '@/assets/fonts/dana/fontiran.css';

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;
Vue.use(HighchartsVue);
Vue.use(VueClipboard);
Vue.use(VuetifyDialog, { context: { vuetify } });
Vue.use(vuePersianFilters);
Vue.use(NotificationPlugin);
Vue.directive('filter-input', FilterInputDirective);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
